var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 18,
    height: 18,
    transform: "translate(-0.002)",
    fill: "#efc066"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tweeter",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(1.5 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M178.618,283.085a.119.119,0,0,0-.05.1,8.2,8.2,0,0,1-.06,1.378,9.139,9.139,0,0,1-.8,2.768,8.856,8.856,0,0,1-1.683,2.452,8.3,8.3,0,0,1-4.267,2.38,9.147,9.147,0,0,1-1.733.2,8.769,8.769,0,0,1-4.976-1.334l-.072-.049a6.26,6.26,0,0,0,3.11-.427,6.128,6.128,0,0,0,1.478-.864,3.117,3.117,0,0,1-2.894-2.153,3.09,3.09,0,0,0,1.334-.044.12.12,0,0,0,.044-.016,3.127,3.127,0,0,1-2.021-1.428,3.027,3.027,0,0,1-.454-1.655,3.066,3.066,0,0,0,1.383.383,3.147,3.147,0,0,1-1.278-1.889,3.106,3.106,0,0,1,.331-2.252,8.893,8.893,0,0,0,6.41,3.249c-.017-.123-.034-.233-.05-.343a3.051,3.051,0,0,1,.454-2.031,2.978,2.978,0,0,1,2.108-1.4,3.027,3.027,0,0,1,2.724.863.156.156,0,0,0,.167.051,6.243,6.243,0,0,0,1.8-.7.334.334,0,0,1,.045-.017c0-.005,0-.005.016-.005A3.161,3.161,0,0,1,178.364,282a6.117,6.117,0,0,0,1.732-.464c0,.006.005.006.01.011-.121.155-.233.315-.359.47A5.965,5.965,0,0,1,178.618,283.085Z",
    transform: "translate(-164.98 -280.065)",
    fill: "#efc066"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8e91aa4c58b16daf46c911fe125f6272.svg";
export { ForwardRef as ReactComponent };